import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import colors from '@theme/colors';

const DateSelectorWrapper = styled.div`
  label {
    color: rgba(0, 0, 0, 0.3);

    &.caption {
      font-size: 12px;
    }

    &.placeholder {
      font-size: inherit;
      position: absolute;
    }
  }

  div {
    margin-top: 4px;
    outline: none;
    color: ${({ isEmpty }) => (isEmpty ? 'transparent' : colors.PRIMARY)};
    width: 5.4em;
  }
`;

const setFocusForTarget = ({ currentTarget: { htmlFor } }) =>
  document.getElementById(htmlFor).focus();

const DateSelector = ({ id, value, caption, placeholder }) => (innerProps) => (
  <DateSelectorWrapper isEmpty={!value}>
    {caption && (
      <label className="caption" htmlFor={id} onClick={setFocusForTarget}>
        {caption}
      </label>
    )}
    {placeholder && !value && (
      <label className="placeholder" htmlFor={id} onClick={setFocusForTarget}>
        {placeholder}
      </label>
    )}
    <div {...innerProps} id={id} tabIndex="0">
      {value ? moment(value).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
    </div>
  </DateSelectorWrapper>
);

export default DateSelector;



// WEBPACK FOOTER //
// ./components/atoms/DatePicker/DateSelector.js